import { render, staticRenderFns } from "./Envolvidos.vue?vue&type=template&id=144751d4"
import script from "./Envolvidos.vue?vue&type=script&lang=js"
export * from "./Envolvidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports